/**
 * The own-muse section's second step: the wall bar's own in-progress chip (`TrainingChip`, the strip's closed slot
 * while one of hers is being made), drawn still. Nothing here reads the viewer or opens anything.
 */
import type {ProofParts} from '@core/proof/ProofPage'
import {TrainingChip} from '@product/ovid/wall/MuseStrip'
import styles from './OwnMuseBuilding.module.scss'

export const ovidProofParts: ProofParts = {
    building: ({name, building}) => (
        <div className={styles.bar} inert>
            <TrainingChip muse={{name, percent: building.percent, thumb: building.thumb.src}} />
        </div>
    ),
}
